import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Rooms from './components/Rooms';
import Services from './components/Services';
import Coffee from './components/Coffee';
import Tours from './components/Tours';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Rooms />
      <Services />
      <Coffee />
      <Tours />
      <Location />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
